import React from 'react';
import { ActionBase } from '../ActionBase';
import { Store } from '../Store';
import { copyObject } from 'common/copyObject';

export type ConnectKiyakuData = {
	scd: string;
	bsn: string;
	burl: string;
};

export const initialConnectKiyakuData: ConnectKiyakuData = {
	scd: undefined,
	bsn: undefined,
	burl: undefined,
};

//////////////////////////////////////////////////
// SaveAction
//////////////////////////////////////////////////
// Action
class SaveAction extends ActionBase {
	connectKiyakuData: ConnectKiyakuData;
}
// Action name
const SaveActionName = SaveAction.toString();

// Action generator
export const saveGenerator = async (dispatch: React.Dispatch<ActionBase>, connectKiyakuData: ConnectKiyakuData) => {
	const action = {
		action: SaveActionName,
		connectKiyakuData,
	} as SaveAction;

	dispatch(action);
};

// Reducer
const saveReducer = (state: Store, action: ActionBase): Store => {
	const thisAction = action as SaveAction;
	const newState: Store = copyObject(state);
	newState.connectKiyakuData = thisAction.connectKiyakuData;
	return newState;
};

////////////////////////////////////////////////////////////////////////////////
// Reduce functions finder
////////////////////////////////////////////////////////////////////////////////
export const ConnectKiyakuReduceFunction = (state: Store, action: ActionBase): Store => {
	switch (action.action) {
		case SaveActionName:
			return saveReducer(state, action);
	}
	return null;
};
